/**
 * OTP bottom-sheet dismiss policies (shared logic; tier UI stays in AuthSheetHost / OTPVerificationSheetContent).
 *
 * - `blocking`: no chrome/backdrop dismiss — verify or explicit in-sheet cancel (abort session).
 * - `gated`: dismiss leaves protected screen (go back / home) — used on verification-required features.
 * - `allow_exit`: legacy escape to MainTabs (avoid for new flows).
 */
export type OtpDismissPolicy = 'blocking' | 'gated' | 'allow_exit';

export function resolveOtpDismissPolicy(params: Record<string, unknown>): OtpDismissPolicy {
  const policy = params.dismissPolicy;
  if (policy === 'blocking' || policy === 'gated' || policy === 'allow_exit') {
    return policy;
  }
  if (params.allowBackToHome === true) {
    return 'allow_exit';
  }
  if (params.context === 'signup') {
    return 'blocking';
  }
  return 'blocking';
}

export function otpChromeDismissBlocked(params: Record<string, unknown>): boolean {
  return resolveOtpDismissPolicy(params) === 'blocking';
}

export function enrichSignupOtpParams(params: Record<string, unknown>): Record<string, unknown> {
  return {
    ...params,
    dismissPolicy: 'blocking' satisfies OtpDismissPolicy,
    context: 'signup',
    skipInitialResend: true,
  };
}

export function enrichGatedOtpParams(params: Record<string, unknown>): Record<string, unknown> {
  return {
    ...params,
    dismissPolicy: 'gated' satisfies OtpDismissPolicy,
    context: params.context ?? 'signin',
  };
}

export function enrichBlockingSigninOtpParams(params: Record<string, unknown>): Record<string, unknown> {
  return {
    ...params,
    dismissPolicy: 'blocking' satisfies OtpDismissPolicy,
    context: 'signin',
  };
}
